module.exports = __webpack_public_path__ + "static/media/teamitem-bg.c84ffe32.svg";